import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import rbacReducer from "../features/rbac/rbacSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    rbac: rbacReducer,
  },

  // ✅ DevTools (auto disabled in production)
  devTools: process.env.NODE_ENV !== "production",

  // ✅ Middleware (future-proof)
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // avoids warnings (toast, etc.)
    }),
});